import { ReactElement } from 'react';
import { SelectDay } from 'pages/Analysis/SchedulesModals/fullProgEditStyles';
import { FORM_VALIDATORS, weekDays } from '../../constants';
import { RegisterOptions, useFormContext, useWatch } from 'react-hook-form';
import { DamScheduleFormValues } from '../../types';
import { SelectDaysContainer } from './styles';

export function SelectDays(): ReactElement {
  const {
    control,
    setValue,
    register,
  } = useFormContext<DamScheduleFormValues>();

  register('weekDays', {
    required: 'Dias necessários',
    ...FORM_VALIDATORS.weekDays,
  } as RegisterOptions<DamScheduleFormValues, 'weekDays'>);

  const daysWatch = useWatch<DamScheduleFormValues, 'weekDays'>({
    control,
    name: 'weekDays',
  });

  function handleSelectDay(day: string): void {
    const newValues = [...daysWatch];
    if (newValues.includes(day)) {
      setValue('weekDays', newValues.filter((item) => item !== day));
      return;
    }

    setValue('weekDays', [...newValues, day]);
  }

  return (
    <SelectDaysContainer>
      {weekDays.map((item) => (
        <SelectDay
          key={item.day}
          isSelected={daysWatch.includes(item.day)}
          onClick={() => handleSelectDay(item.day)}
          disabled={false}
        >
          {item.name}
        </SelectDay>
      ))}
    </SelectDaysContainer>
  );
}
